import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import ExhibitionFilter from "../components/ExhibitionFilter";
import bi_filter from "../assets/icons/bi_filter.png";
import avatar from "../assets/images/avatar.png";
import { Link } from "react-router-dom";

const ExhibitionUserList = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const [exhibitionFilter, setExhibitionFilter] = useState(false);

  const toggleExhibitionFilter = () => {
    setExhibitionFilter(!exhibitionFilter);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Exhibition Master" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex my-8 mx-4 justify-between mr-10">
        <div className={`${exhibitionFilter ? "w-[80%]" : "w-[95%]"}`}>
          <p className="text-[16px]">User List</p>

          {/* User 1 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E] ">
                  praveens@gmail.com
                </p>
              </div>
            </div>
          </div>
          {/* User 2 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E]">praveens@gmail.com</p>
              </div>
            </div>
          </div>
          {/* User 3 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E]">praveens@gmail.com</p>
              </div>
            </div>
          </div>
          {/* User 4 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E]">praveens@gmail.com</p>
              </div>
            </div>
          </div>
          {/* User 5 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E]">praveens@gmail.com</p>
              </div>
            </div>
          </div>
          {/* User 6 */}
          <div className="mt-4">
            <div className="flex">
              <input type="checkbox" className="w-5 mr-4" />
              <div className="flex items-center w-full p-3 rounded-xl shadow-md overflow-auto">
                <img
                  src={avatar}
                  alt="avatar"
                  className="w-8 rounded-full mr-3"
                />
                <p className="text-[18px] text-[#0A1629] font-bold mr-8">
                  Praveen Sharma
                </p>
                <p className="text-[14px] text-[#91929E]">praveens@gmail.com</p>
              </div>
            </div>
          </div>

          {/* save & create New */}

          <div className="w-[95%] ml-8">
            <div className=" mt-4 flex w-full justify-between items-center create-foot">
              <div className="text-[#2F80ED] text-[16px] underline font-bold cursor-pointer mt-8">
                Save & Create New
              </div>
              <div className="flex text-[14px] w-[50%] justify-end mt-8">
                <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[30%] action--buttons">
                  Discard
                </button>
                <Link
                  to="/exhibition/exhibitionDetails"
                  className="bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[30%] text-center action--buttons"
                >
                  Send
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={`${exhibitionFilter ? "w-[14rem]" : ""} `}>
          <div className="flex justify-end mr-4 w-full">
            <div className="w-full flex justify-end filter-icon ">
              <img
                src={bi_filter}
                alt="filters"
                className="cursor-pointer "
                onClick={toggleExhibitionFilter}
              />
            </div>
          </div>
          {exhibitionFilter ? (
            <div className="w-full exhibition-filter top-32">
              <ExhibitionFilter />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default ExhibitionUserList;
